const OutrightMapper = (data, context) => {
    return data;
};

export default OutrightMapper;
